import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import Button from 'Components/UI/Button';
import RichTextEditor from 'Components/UI/RichTextEditor';
import useEventTracking from 'EventTracking/useEventTrackingLogEvent';

const useStyles = makeStyles(theme => ({
  root: {
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  iconButton: {
    marginTop: theme.spacing(1),
  },
}));

export default function PostMessageField({ onSave, sendDisabled }) {
  const classes = useStyles();
  const [content, setContent] = React.useState('');
  const { logEvent } = useEventTracking();

  return (
    <Paper elevation={0} component="form" className={classes.root}>
      <RichTextEditor
        readOnly={sendDisabled}
        value={content}
        onChange={setContent}
        test="post-message-field"
        size="xs"
      />
      <Button
        onClick={(e) => {
          onSave(e, content);
          setContent('');
          logEvent('Clicked Post On A Post Message Field');
        }}
        type="submit"
        test="send-message"
        className={classes.iconButton}
        aria-label="send message"
        color="primary"
        disabled={sendDisabled}
        variant="contained"
        disableElevation
      >
        Post
      </Button>
    </Paper>
  );
}

PostMessageField.defaultProps = {
  sendDisabled: false,
};

PostMessageField.propTypes = {
  onSave: PropTypes.func.isRequired,
  sendDisabled: PropTypes.bool,
};
